import { Suspense, lazy } from "react";
import { RouteObject } from "../../helpers/tixxt-router";
import Loading from "../shared/Loading";

const MemberMapPage = lazy(() => import("./MemberMapPage"));

const mapRoutes: RouteObject[] = [
  {
    path: "/map",
    element: (
      <Suspense fallback={<Loading />}>
        <MemberMapPage />
      </Suspense>
    ),
  },
  {
    path: "/members/map",
    element: (
      <Suspense fallback={<Loading />}>
        <MemberMapPage />
      </Suspense>
    ),
  },
  {
    path: "/groups/:groupSlug/map",
    element: (
      <Suspense fallback={<Loading />}>
        <MemberMapPage groupContext />
      </Suspense>
    ),
  },
];

export default mapRoutes;
